import { Component } from '@angular/core'

@Component({
  selector: 'se-po-gender-select-docs',
  templateUrl: './gender-select-docs.component.html',
  styleUrls: ['./gender-select-docs.component.scss'],
  standalone: false,
})
export class GenderSelectDocsComponent {
}
